import { Pipe, PipeTransform } from '@angular/core';

import { MtnaPopoverConfig } from '@mtna/lib-ui';
import { Option } from '@mtna/rds-packaging-ui';

/**
 * Creates a MtnaPopoverConfig for a given packaging Option
 * in order to display the option's description.
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsOptionPopoverConfig'
})
export class RdsOptionPopoverConfigPipe implements PipeTransform {
  /**
   * Creates a MtnaPopoverConfig for a given packaging Option
   * in order to display the option's description.
   *
   * @param value packaging `Option`
   * @returns popover config describing the packaging option
   */
  transform(value: Option): MtnaPopoverConfig {
    return !value ? null : new MtnaPopoverConfig(value.name, value.description);
  }
}
